  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">360 degree created by HR ({{counterListData.length}})</p>
          </div>
          <div class="popup-close">
            <div class="mr-30">
  
              <label class="fs-16 font_regular mr-15">Incomplete</label>
              <mat-slide-toggle class="toggle-element mr-20" [(ngModel)]="isToggleChecked" (change)="get360CounterPopUp()"></mat-slide-toggle>
              <label class="fs-16 font_regular mr-15">Complete</label>

            </div>
            <button class="download-btn" (click)="onClickDownloadScoresOfSurveys('360_degree_created_by_HR')">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              Download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
  
      </ion-col>
    </ion-row>
  
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="Market-correction-employees-table" id="360_degree_created_by_HR">
            <thead>
              <tr>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Start Date
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    End Date
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Name of 360 Review
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of self
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of peers
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of subordinates
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of superior
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of internal customer
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    No. of external customer
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                  Total Employee
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                   Completed
                  </div>
                </th>
                <th class="fs-14 font_bold cl-black">
                  <div class="icon-style">
                    Incompleted
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of counterListData">
                <td>{{item.startDate | date:'dd-MM-yyyy'}}</td>
                <td>{{item.endDate | date:'dd-MM-yyyy'}}</td>
                <td>{{item.reviewName}}</td>
                <td>{{item.noOfSelf}}</td>
                <td>{{item.noOfPeer}}</td>
                <td>{{item.noOfSubordinate}}</td>
                <td>{{item.noOfSuperior}}</td>
                <td>{{item.noOfInternalCustomer}}</td>
                <td>{{item.noOfExternalCustomer}}</td>
                <td>{{item.noOfTotalEmployee}}</td>
                <td>{{item.noOfCompleted}}</td>
                <td>{{item.noOfIncompleted}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
